export const countries = [
  { iso2: 'AF', name: 'Afghanistan', unicodeFlag: '🇦🇫' },
  { iso2: 'AX', name: 'Aland Islands', unicodeFlag: '🇦🇽' },
  { iso2: 'AL', name: 'Albania', unicodeFlag: '🇦🇱' },
  { iso2: 'DZ', name: 'Algeria', unicodeFlag: '🇩🇿' },
  { iso2: 'AS', name: 'American Samoa', unicodeFlag: '🇦🇸' },
  { iso2: 'AD', name: 'Andorra', unicodeFlag: '🇦🇩' },
  { iso2: 'AO', name: 'Angola', unicodeFlag: '🇦🇴' },
  { iso2: 'AI', name: 'Anguilla', unicodeFlag: '🇦🇮' },
  { iso2: 'AQ', name: 'Antarctica', unicodeFlag: '🇦🇶' },
  { iso2: 'AG', name: 'Antigua and Barbuda', unicodeFlag: '🇦🇬' },
  { iso2: 'AR', name: 'Argentina', unicodeFlag: '🇦🇷' },
  { iso2: 'AM', name: 'Armenia', unicodeFlag: '🇦🇲' },
  { iso2: 'AW', name: 'Aruba', unicodeFlag: '🇦🇼' },
  { iso2: 'AU', name: 'Australia', unicodeFlag: '🇦🇺' },
  { iso2: 'AT', name: 'Austria', unicodeFlag: '🇦🇹' },
  { iso2: 'AZ', name: 'Azerbaijan', unicodeFlag: '🇦🇿' },
  { iso2: 'BH', name: 'Bahrain', unicodeFlag: '🇧🇭' },
  { iso2: 'BD', name: 'Bangladesh', unicodeFlag: '🇧🇩' },
  { iso2: 'BB', name: 'Barbados', unicodeFlag: '🇧🇧' },
  { iso2: 'BY', name: 'Belarus', unicodeFlag: '🇧🇾' },
  { iso2: 'BE', name: 'Belgium', unicodeFlag: '🇧🇪' },
  { iso2: 'BZ', name: 'Belize', unicodeFlag: '🇧🇿' },
  { iso2: 'BJ', name: 'Benin', unicodeFlag: '🇧🇯' },
  { iso2: 'BM', name: 'Bermuda', unicodeFlag: '🇧🇲' },
  { iso2: 'BT', name: 'Bhutan', unicodeFlag: '🇧🇹' },
  { iso2: 'BO', name: 'Bolivia', unicodeFlag: '🇧🇴' },
  { iso2: 'BA', name: 'Bosnia and Herzegovina', unicodeFlag: '🇧🇦' },
  { iso2: 'BW', name: 'Botswana', unicodeFlag: '🇧🇼' },
  { iso2: 'BV', name: 'Bouvet Island', unicodeFlag: '' },
  { iso2: 'BR', name: 'Brazil', unicodeFlag: '🇧🇷' },
  { iso2: 'IO', name: 'British Indian Ocean Territory', unicodeFlag: '🇮🇴' },
  { iso2: 'VG', name: 'British Virgin Islands', unicodeFlag: '🇻🇬' },
  { iso2: 'BN', name: 'Brunei Darussalam', unicodeFlag: '🇧🇳' },
  { iso2: 'BG', name: 'Bulgaria', unicodeFlag: '🇧🇬' },
  { iso2: 'BF', name: 'Burkina Faso', unicodeFlag: '🇧🇫' },
  { iso2: 'BI', name: 'Burundi', unicodeFlag: '🇧🇮' },
  { iso2: 'KH', name: 'Cambodia', unicodeFlag: '🇰🇭' },
  { iso2: 'CM', name: 'Cameroon', unicodeFlag: '🇨🇲' },
  { iso2: 'CA', name: 'Canada', unicodeFlag: '🇨🇦' },
  { iso2: 'CV', name: 'Cape Verde', unicodeFlag: '🇨🇻' },
  { iso2: 'KY', name: 'Cayman Islands', unicodeFlag: '🇰🇾' },
  { iso2: 'CF', name: 'Central African Republic', unicodeFlag: '🇨🇫' },
  { iso2: 'TD', name: 'Chad', unicodeFlag: '🇹🇩' },
  { iso2: 'CL', name: 'Chile', unicodeFlag: '🇨🇱' },
  { iso2: 'CN', name: 'China', unicodeFlag: '🇨🇳' },
  { iso2: 'CX', name: 'Christmas Island', unicodeFlag: '🇨🇽' },
  { iso2: 'CC', name: 'Cocos (Keeling) Islands', unicodeFlag: '🇨🇨' },
  { iso2: 'CO', name: 'Colombia', unicodeFlag: '🇨🇴' },
  { iso2: 'KM', name: 'Comoros', unicodeFlag: '🇰🇲' },
  { iso2: 'CD', name: 'Congo, Democratic Republic of the', unicodeFlag: '🇨🇩' },
  { iso2: 'CG', name: 'Congo, Republic of the', unicodeFlag: '🇨🇬' },
  { iso2: 'CK', name: 'Cook Islands', unicodeFlag: '🇨🇰' },
  { iso2: 'CR', name: 'Costa Rica', unicodeFlag: '🇨🇷' },
  { iso2: 'CI', name: "Cote d'Ivoire", unicodeFlag: '🇨🇮' },
  { iso2: 'HR', name: 'Croatia', unicodeFlag: '🇭🇷' },
  { iso2: 'CU', name: 'Cuba', unicodeFlag: '🇨🇺' },
  { iso2: 'CY', name: 'Cyprus', unicodeFlag: '🇨🇾' },
  { iso2: 'CZ', name: 'Czech Republic', unicodeFlag: '🇨🇿' },
  { iso2: 'DK', name: 'Denmark', unicodeFlag: '🇩🇰' },
  { iso2: 'DJ', name: 'Djibouti', unicodeFlag: '🇩🇯' },
  { iso2: 'DM', name: 'Dominica', unicodeFlag: '🇩🇲' },
  { iso2: 'DO', name: 'Dominican Republic', unicodeFlag: '🇩🇴' },
  { iso2: 'TL', name: 'East Timor', unicodeFlag: '🇹🇱' },
  { iso2: 'EC', name: 'Ecuador', unicodeFlag: '🇪🇨' },
  { iso2: 'EG', name: 'Egypt', unicodeFlag: '🇪🇬' },
  { iso2: 'SV', name: 'El Salvador', unicodeFlag: '🇸🇻' },
  { iso2: 'GQ', name: 'Equatorial Guinea', unicodeFlag: '🇬🇶' },
  { iso2: 'ER', name: 'Eritrea', unicodeFlag: '🇪🇷' },
  { iso2: 'EE', name: 'Estonia', unicodeFlag: '🇪🇪' },
  { iso2: 'ET', name: 'Ethiopia', unicodeFlag: '🇪🇹' },
  { iso2: 'FK', name: 'Falkland Islands (Islas Malvinas)', unicodeFlag: '🇫🇰' },
  { iso2: 'FO', name: 'Faroe Islands', unicodeFlag: '🇫🇴' },
  { iso2: 'FJ', name: 'Fiji', unicodeFlag: '🇫🇯' },
  { iso2: 'FI', name: 'Finland', unicodeFlag: '🇫🇮' },
  { iso2: 'FR', name: 'France', unicodeFlag: '🇫🇷' },
  { iso2: 'GF', name: 'French Guiana', unicodeFlag: '🇬🇫' },
  { iso2: 'PF', name: 'French Polynesia', unicodeFlag: '🇵🇫' },
  {
    iso2: 'TF',
    name: 'French Southern and Antarctic Lands',
    unicodeFlag: '🇹🇫',
  },
  { iso2: 'GA', name: 'Gabon', unicodeFlag: '🇬🇦' },
  { iso2: 'GE', name: 'Georgia', unicodeFlag: '🇬🇪' },
  { iso2: 'DE', name: 'Germany', unicodeFlag: '🇩🇪' },
  { iso2: 'GH', name: 'Ghana', unicodeFlag: '🇬🇭' },
  { iso2: 'GI', name: 'Gibraltar', unicodeFlag: '🇬🇮' },
  { iso2: 'GR', name: 'Greece', unicodeFlag: '🇬🇷' },
  { iso2: 'GL', name: 'Greenland', unicodeFlag: '🇬🇱' },
  { iso2: 'GD', name: 'Grenada', unicodeFlag: '🇬🇩' },
  { iso2: 'GP', name: 'Guadeloupe', unicodeFlag: '🇬🇵' },
  { iso2: 'GU', name: 'Guam', unicodeFlag: '🇬🇺' },
  { iso2: 'GT', name: 'Guatemala', unicodeFlag: '🇬🇹' },
  { iso2: 'GG', name: 'Guernsey', unicodeFlag: '🇬🇬' },
  { iso2: 'GN', name: 'Guinea', unicodeFlag: '🇬🇳' },
  { iso2: 'GW', name: 'Guinea-Bissau', unicodeFlag: '🇬🇼' },
  { iso2: 'GY', name: 'Guyana', unicodeFlag: '🇬🇾' },
  { iso2: 'HT', name: 'Haiti', unicodeFlag: '🇭🇹' },
  { iso2: 'HM', name: 'Heard Island and McDonald Islands', unicodeFlag: '' },
  { iso2: 'VA', name: 'Holy See (Vatican City)', unicodeFlag: '🇻🇦' },
  { iso2: 'HN', name: 'Honduras', unicodeFlag: '🇭🇳' },
  { iso2: 'HK', name: 'Hong Kong (SAR)', unicodeFlag: '🇭🇰' },
  { iso2: 'HU', name: 'Hungary', unicodeFlag: '🇭🇺' },
  { iso2: 'IS', name: 'Iceland', unicodeFlag: '🇮🇸' },
  { iso2: 'IN', name: 'India', unicodeFlag: '🇮🇳' },
  { iso2: 'ID', name: 'Indonesia', unicodeFlag: '🇮🇩' },
  { iso2: 'IR', name: 'Iran', unicodeFlag: '🇮🇷' },
  { iso2: 'IQ', name: 'Iraq', unicodeFlag: '🇮🇶' },
  { iso2: 'IE', name: 'Ireland', unicodeFlag: '🇮🇪' },
  { iso2: 'IM', name: 'Isle of Man', unicodeFlag: '🇮🇲' },
  { iso2: 'IL', name: 'Israel', unicodeFlag: '🇮🇱' },
  { iso2: 'IT', name: 'Italy', unicodeFlag: '🇮🇹' },
  { iso2: 'JM', name: 'Jamaica', unicodeFlag: '🇯🇲' },
  { iso2: 'JP', name: 'Japan', unicodeFlag: '🇯🇵' },
  { iso2: 'JE', name: 'Jersey', unicodeFlag: '🇯🇪' },
  { iso2: 'JO', name: 'Jordan', unicodeFlag: '🇯🇴' },
  { iso2: 'KZ', name: 'Kazakhstan', unicodeFlag: '🇰🇿' },
  { iso2: 'KE', name: 'Kenya', unicodeFlag: '🇰🇪' },
  { iso2: 'KI', name: 'Kiribati', unicodeFlag: '🇰🇮' },
  { iso2: 'KP', name: 'Korea, North', unicodeFlag: '🇰🇵' },
  { iso2: 'KR', name: 'Korea, South', unicodeFlag: '🇰🇷' },
  { iso2: 'KW', name: 'Kuwait', unicodeFlag: '🇰🇼' },
  { iso2: 'KG', name: 'Kyrgyzstan', unicodeFlag: '🇰🇬' },
  { iso2: 'LA', name: 'Laos', unicodeFlag: '🇱🇦' },
  { iso2: 'LV', name: 'Latvia', unicodeFlag: '🇱🇻' },
  { iso2: 'LB', name: 'Lebanon', unicodeFlag: '🇱🇧' },
  { iso2: 'LS', name: 'Lesotho', unicodeFlag: '🇱🇸' },
  { iso2: 'LR', name: 'Liberia', unicodeFlag: '🇱🇷' },
  { iso2: 'LY', name: 'Libya', unicodeFlag: '🇱🇾' },
  { iso2: 'LI', name: 'Liechtenstein', unicodeFlag: '🇱🇮' },
  { iso2: 'LT', name: 'Lithuania', unicodeFlag: '🇱🇹' },
  { iso2: 'LU', name: 'Luxembourg', unicodeFlag: '🇱🇺' },
  { iso2: 'MO', name: 'Macao', unicodeFlag: '🇲🇴' },
  {
    iso2: 'MK',
    name: 'Macedonia, The Former Yugoslav Republic of',
    unicodeFlag: '🇲🇰',
  },
  { iso2: 'MG', name: 'Madagascar', unicodeFlag: '🇲🇬' },
  { iso2: 'MW', name: 'Malawi', unicodeFlag: '🇲🇼' },
  { iso2: 'MY', name: 'Malaysia', unicodeFlag: '🇲🇾' },
  { iso2: 'MV', name: 'Maldives', unicodeFlag: '🇲🇻' },
  { iso2: 'ML', name: 'Mali', unicodeFlag: '🇲🇱' },
  { iso2: 'MT', name: 'Malta', unicodeFlag: '🇲🇹' },
  { iso2: 'MH', name: 'Marshall Islands', unicodeFlag: '🇲🇭' },
  { iso2: 'MQ', name: 'Martinique', unicodeFlag: '🇲🇶' },
  { iso2: 'MR', name: 'Mauritania', unicodeFlag: '🇲🇷' },
  { iso2: 'MU', name: 'Mauritius', unicodeFlag: '🇲🇺' },
  { iso2: 'YT', name: 'Mayotte', unicodeFlag: '🇾🇹' },
  { iso2: 'MX', name: 'Mexico', unicodeFlag: '🇲🇽' },
  { iso2: 'FM', name: 'Micronesia, Federated States of', unicodeFlag: '🇫🇲' },
  { iso2: 'MD', name: 'Moldova', unicodeFlag: '🇲🇩' },
  { iso2: 'MC', name: 'Monaco', unicodeFlag: '🇲🇨' },
  { iso2: 'MN', name: 'Mongolia', unicodeFlag: '🇲🇳' },
  { iso2: 'ME', name: 'Montenegro', unicodeFlag: '🇲🇪' },
  { iso2: 'MS', name: 'Montserrat', unicodeFlag: '🇲🇸' },
  { iso2: 'MA', name: 'Morocco', unicodeFlag: '🇲🇦' },
  { iso2: 'MZ', name: 'Mozambique', unicodeFlag: '🇲🇿' },
  { iso2: 'MM', name: 'Myanmar', unicodeFlag: '🇲🇲' },
  { iso2: 'NA', name: 'Namibia', unicodeFlag: '🇳🇦' },
  { iso2: 'NR', name: 'Nauru', unicodeFlag: '🇳🇷' },
  { iso2: 'NP', name: 'Nepal', unicodeFlag: '🇳🇵' },
  { iso2: 'NL', name: 'Netherlands', unicodeFlag: '🇳🇱' },
  { iso2: 'AN', name: 'Netherlands Antilles', unicodeFlag: '' },
  { iso2: 'NC', name: 'New Caledonia', unicodeFlag: '🇳🇨' },
  { iso2: 'NZ', name: 'New Zealand', unicodeFlag: '🇳🇿' },
  { iso2: 'NI', name: 'Nicaragua', unicodeFlag: '🇳🇮' },
  { iso2: 'NE', name: 'Niger', unicodeFlag: '🇳🇪' },
  { iso2: 'NG', name: 'Nigeria', unicodeFlag: '🇳🇬' },
  { iso2: 'NU', name: 'Niue', unicodeFlag: '🇳🇺' },
  { iso2: 'NF', name: 'Norfolk Island', unicodeFlag: '🇳🇫' },
  { iso2: 'MP', name: 'Northern Mariana Islands', unicodeFlag: '🇲🇵' },
  { iso2: 'NO', name: 'Norway', unicodeFlag: '🇳🇴' },
  { iso2: 'OM', name: 'Oman', unicodeFlag: '🇴🇲' },
  { iso2: 'PK', name: 'Pakistan', unicodeFlag: '🇵🇰' },
  { iso2: 'PW', name: 'Palau', unicodeFlag: '🇵🇼' },
  { iso2: 'PS', name: 'Palestinian Territory, Occupied', unicodeFlag: '🇵🇸' },
  { iso2: 'PA', name: 'Panama', unicodeFlag: '🇵🇦' },
  { iso2: 'PG', name: 'Papua New Guinea', unicodeFlag: '🇵🇬' },
  { iso2: 'PY', name: 'Paraguay', unicodeFlag: '🇵🇾' },
  { iso2: 'PE', name: 'Peru', unicodeFlag: '🇵🇪' },
  { iso2: 'PH', name: 'Philippines', unicodeFlag: '🇵🇭' },
  { iso2: 'PN', name: 'Pitcairn Islands', unicodeFlag: '🇵🇳' },
  { iso2: 'PL', name: 'Poland', unicodeFlag: '🇵🇱' },
  { iso2: 'PT', name: 'Portugal', unicodeFlag: '🇵🇹' },
  { iso2: 'PR', name: 'Puerto Rico', unicodeFlag: '🇵🇷' },
  { iso2: 'QA', name: 'Qatar', unicodeFlag: '🇶🇦' },
  { iso2: 'RE', name: 'Reunion', unicodeFlag: '🇷🇪' },
  { iso2: 'RO', name: 'Romania', unicodeFlag: '🇷🇴' },
  { iso2: 'RU', name: 'Russia', unicodeFlag: '🇷🇺' },
  { iso2: 'RW', name: 'Rwanda', unicodeFlag: '🇷🇼' },
  { iso2: 'BL', name: 'Saint Barthelemy', unicodeFlag: '🇧🇱' },
  { iso2: 'SH', name: 'Saint Helena', unicodeFlag: '🇸🇭' },
  { iso2: 'KN', name: 'Saint Kitts and Nevis', unicodeFlag: '🇰🇳' },
  { iso2: 'LC', name: 'Saint Lucia', unicodeFlag: '🇱🇨' },
  { iso2: 'MF', name: 'Saint Martin (French part)', unicodeFlag: '' },
  { iso2: 'PM', name: 'Saint Pierre and Miquelon', unicodeFlag: '🇵🇲' },
  { iso2: 'VC', name: 'Saint Vincent and the Grenadines', unicodeFlag: '🇻🇨' },
  { iso2: 'WS', name: 'Samoa', unicodeFlag: '🇼🇸' },
  { iso2: 'SM', name: 'San Marino', unicodeFlag: '🇸🇲' },
  { iso2: 'ST', name: 'Sao Tome and Principe', unicodeFlag: '🇸🇹' },
  { iso2: 'SA', name: 'Saudi Arabia', unicodeFlag: '🇸🇦' },
  { iso2: 'SN', name: 'Senegal', unicodeFlag: '🇸🇳' },
  { iso2: 'RS', name: 'Serbia', unicodeFlag: '🇷🇸' },
  { iso2: 'SC', name: 'Seychelles', unicodeFlag: '🇸🇨' },
  { iso2: 'SL', name: 'Sierra Leone', unicodeFlag: '🇸🇱' },
  { iso2: 'SG', name: 'Singapore', unicodeFlag: '🇸🇬' },
  { iso2: 'SK', name: 'Slovakia', unicodeFlag: '🇸🇰' },
  { iso2: 'SI', name: 'Slovenia', unicodeFlag: '🇸🇮' },
  { iso2: 'SB', name: 'Solomon Islands', unicodeFlag: '🇸🇧' },
  { iso2: 'SO', name: 'Somalia', unicodeFlag: '🇸🇴' },
  { iso2: 'ZA', name: 'South Africa', unicodeFlag: '🇿🇦' },
  {
    iso2: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    unicodeFlag: '🇬🇸',
  },
  { iso2: 'ES', name: 'Spain', unicodeFlag: '🇪🇸' },
  { iso2: 'LK', name: 'Sri Lanka', unicodeFlag: '🇱🇰' },
  { iso2: 'SD', name: 'Sudan', unicodeFlag: '🇸🇩' },
  { iso2: 'SR', name: 'Suriname', unicodeFlag: '🇸🇷' },
  { iso2: 'SJ', name: 'Svalbard', unicodeFlag: '' },
  { iso2: 'SZ', name: 'Swaziland', unicodeFlag: '🇸🇿' },
  { iso2: 'SE', name: 'Sweden', unicodeFlag: '🇸🇪' },
  { iso2: 'CH', name: 'Switzerland', unicodeFlag: '🇨🇭' },
  { iso2: 'SY', name: 'Syria', unicodeFlag: '🇸🇾' },
  { iso2: 'TW', name: 'Taiwan', unicodeFlag: '🇹🇼' },
  { iso2: 'TJ', name: 'Tajikistan', unicodeFlag: '🇹🇯' },
  { iso2: 'TZ', name: 'Tanzania', unicodeFlag: '🇹🇿' },
  { iso2: 'TH', name: 'Thailand', unicodeFlag: '🇹🇭' },
  { iso2: 'BS', name: 'The Bahamas', unicodeFlag: '🇧🇸' },
  { iso2: 'GM', name: 'The Gambia', unicodeFlag: '🇬🇲' },
  { iso2: 'TG', name: 'Togo', unicodeFlag: '🇹🇬' },
  { iso2: 'TK', name: 'Tokelau', unicodeFlag: '🇹🇰' },
  { iso2: 'TO', name: 'Tonga', unicodeFlag: '🇹🇴' },
  { iso2: 'TT', name: 'Trinidad and Tobago', unicodeFlag: '🇹🇹' },
  { iso2: 'TN', name: 'Tunisia', unicodeFlag: '🇹🇳' },
  { iso2: 'TR', name: 'Turkey', unicodeFlag: '🇹🇷' },
  { iso2: 'TM', name: 'Turkmenistan', unicodeFlag: '🇹🇲' },
  { iso2: 'TC', name: 'Turks and Caicos Islands', unicodeFlag: '🇹🇨' },
  { iso2: 'TV', name: 'Tuvalu', unicodeFlag: '🇹🇻' },
  { iso2: 'UG', name: 'Uganda', unicodeFlag: '🇺🇬' },
  { iso2: 'UA', name: 'Ukraine', unicodeFlag: '🇺🇦' },
  { iso2: 'AE', name: 'United Arab Emirates', unicodeFlag: '🇦🇪' },
  { iso2: 'GB', name: 'United Kingdom', unicodeFlag: '🇬🇧' },
  { iso2: 'US', name: 'United States', unicodeFlag: '🇺🇸' },
  { iso2: 'UM', name: 'United States Minor Outlying Islands', unicodeFlag: '' },
  { iso2: 'UY', name: 'Uruguay', unicodeFlag: '🇺🇾' },
  { iso2: 'UZ', name: 'Uzbekistan', unicodeFlag: '🇺🇿' },
  { iso2: 'VU', name: 'Vanuatu', unicodeFlag: '🇻🇺' },
  { iso2: 'VE', name: 'Venezuela', unicodeFlag: '🇻🇪' },
  { iso2: 'VN', name: 'Vietnam', unicodeFlag: '🇻🇳' },
  { iso2: 'VI', name: 'Virgin Islands', unicodeFlag: '🇻🇮' },
  { iso2: 'WF', name: 'Wallis and Futuna', unicodeFlag: '🇼🇫' },
  { iso2: 'EH', name: 'Western Sahara', unicodeFlag: '🇪🇭' },
  { iso2: 'YE', name: 'Yemen', unicodeFlag: '🇾🇪' },
  { iso2: 'ZM', name: 'Zambia', unicodeFlag: '🇿🇲' },
  { iso2: 'ZW', name: 'Zimbabwe', unicodeFlag: '🇿🇼' },
];
